import { Container } from 'inversify'

import {
  IceHockeyIncidentId,
  IncidentId,
} from '@collector/sportsapi-client-legacy'
import { AddIncident } from '@mobile/ActionQueue/Actions/Actions'
import { RelationIoCBindings } from '@mobile/views/Relation/Shared/RelationDependencies/types'
import { IncidentHandler } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/IncidentHandlersConfiguration'
import { RelationSportCommonIoCBindings } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/relationSportCommonDependencies'

export function bindIncidentHandlersConfiguration(ioc: Container): void {
  ioc
    .bind(RelationSportCommonIoCBindings.IncidentHandlersConfiguration)
    .toDynamicValue(async (ctx) => {
      const [
        probableClock,
        probableEvent,
        actionQueue,
        eventStatusesConfiguration,
      ] = await Promise.all([
        ctx.container.getAsync(RelationIoCBindings.ProbableClock),
        ctx.container.getAsync(RelationIoCBindings.ProbableEvent),
        ctx.container.getAsync(RelationIoCBindings.ActionQueue),
        ctx.container.getAsync(
          RelationSportCommonIoCBindings.EventStatusesConfiguration,
        ),
      ])

      const isDisabledByCurrentEventStatus = (
        incidentId: IncidentId,
      ): boolean => {
        const eventStatusConfiguration =
          eventStatusesConfiguration[probableEvent.value.status_id]

        return !eventStatusConfiguration?.allowedIncidents?.includes(incidentId)
      }

      const addIncident: IncidentHandler['handler'] = ({
        incidentId,
        participantId,
        status,
        time = {
          minute: probableClock.value.minute,
          second: probableClock.value.second,
        },
        attributeIds = [],
      }) => {
        actionQueue.value.add(
          new AddIncident({
            incident_id: incidentId,
            status_id: status ?? probableEvent.value.status_id,
            participant_team_id: participantId,
            ...time,
            attribute_ids: attributeIds,
          }),
        )
      }

      return {
        [IceHockeyIncidentId.Hit]: {
          handler: ({ participantId, incidentId, status, time }) =>
            addIncident({
              participantId,
              incidentId,
              status,
              time,
            }),
          disabled: ({ incidentId }) =>
            isDisabledByCurrentEventStatus(incidentId),
        },
        fallbackHandler: {
          handler: ({ incidentId, participantId, status, time }) =>
            addIncident({
              time,
              status,
              incidentId,
              participantId,
            }),
          disabled: () => false,
        },
      }
    })
}
